import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * shadcn-canonical class merger. Combines clsx (conditional classes) with
 * tailwind-merge (resolves Tailwind utility conflicts so later classes win).
 */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs))
